export default "__VITE_ASSET__3864c816__"